import { keyBy, startCase } from "lodash-es";
import { copy } from "shared/assets";
import { IInfoBlockType, IMainInfoBlock } from "Venues/types";

const { infoBlocks } = copy;

export const infoBlockList = [
  {
    type: IMainInfoBlock.logistics,
    label: startCase(IMainInfoBlock.logistics),
    subItems: [
      {
        type: IInfoBlockType.parking,
        label: startCase(IInfoBlockType.parking),
      },
      {
        type: IInfoBlockType.loadInLoadOut,
        label: infoBlocks.loadInLoadOut,
      },
      {
        type: IInfoBlockType.drivingPermits,
        label: startCase(IInfoBlockType.drivingPermits),
      },
    ],
  },
  {
    type: IMainInfoBlock.regulations,
    label: startCase(IMainInfoBlock.regulations),
    subItems: [
      {
        type: IInfoBlockType.earliestGetIn,
        label: infoBlocks.earliestGetIn,
      },
      {
        type: IInfoBlockType.curfew,
        label: startCase(IInfoBlockType.curfew),
      },
      {
        type: IInfoBlockType.ageRestriction,
        label: startCase(IInfoBlockType.ageRestriction),
      },
      {
        type: IInfoBlockType.pyroFireworksConfetti,
        label: infoBlocks.pyroFireworksConfetti,
      },
    ],
  },
  {
    type: IMainInfoBlock.electricity,
    label: startCase(IMainInfoBlock.electricity),
    subItems: [
      {
        type: IInfoBlockType.powerSound,
        label: infoBlocks.powerSound,
      },
      {
        type: IInfoBlockType.powerLights,
        label: infoBlocks.powerLights,
      },
      {
        type: IInfoBlockType.powerVideo,
        label: infoBlocks.powerVideo,
      },
      {
        type: IInfoBlockType.powerRigging,
        label: infoBlocks.powerRigging,
      },
      {
        type: IInfoBlockType.powerBackline,
        label: infoBlocks.powerBackline,
      },
      {
        type: IInfoBlockType.powerFOH,
        label: infoBlocks.powerFOH,
      },
    ],
  },
  {
    type: IMainInfoBlock.wirelessFrequencies,
    label: startCase(IMainInfoBlock.wirelessFrequencies),
    subItems: [
      {
        type: IInfoBlockType.freeAllowedFrequencies,
        label: startCase(IInfoBlockType.freeAllowedFrequencies),
      },
      {
        type: IInfoBlockType.frequenciesWithLicense,
        label: infoBlocks.frequenciesWithLicense,
      },
      {
        type: IInfoBlockType.remarks,
        label: startCase(IInfoBlockType.remarks),
      },
    ],
  },
  {
    type: IMainInfoBlock.communication,
    label: startCase(IMainInfoBlock.communication),
    subItems: [
      {
        type: IInfoBlockType.internet,
        label: startCase(IInfoBlockType.internet),
      },
      {
        type: IInfoBlockType.phone,
        label: startCase(IInfoBlockType.phone),
      },
      {
        type: IInfoBlockType.fax,
        label: startCase(IInfoBlockType.fax),
      },
    ],
  },
  {
    type: IMainInfoBlock.dressingRooms,
    label: startCase(IMainInfoBlock.dressingRooms),
    subItems: [
      {
        type: IInfoBlockType.rooms,
        label: infoBlocks.rooms,
      },
      {
        type: IInfoBlockType.toilets,
        label: startCase(IInfoBlockType.toilets),
      },
      {
        type: IInfoBlockType.showers,
        label: startCase(IInfoBlockType.showers),
      },
    ],
  },
  {
    type: IMainInfoBlock.offices,
    label: startCase(IMainInfoBlock.offices),
    subItems: [
      {
        type: IInfoBlockType.offices,
        label: infoBlocks.offices,
      },
    ],
  },
  {
    type: IMainInfoBlock.catering,
    label: startCase(IMainInfoBlock.catering),
    subItems: [
      {
        type: IInfoBlockType.cateringArea,
        label: infoBlocks.cateringArea,
      },
      {
        type: IInfoBlockType.kitchenFacilities,
        label: infoBlocks.kitchenFacilities,
      },
      {
        type: IInfoBlockType.cateringPower,
        label: startCase(IInfoBlockType.cateringPower),
      },
    ],
  },
  {
    type: IMainInfoBlock.merchandise,
    label: startCase(IMainInfoBlock.merchandise),
    subItems: [
      {
        type: IInfoBlockType.boot,
        label: infoBlocks.boot,
      },
      {
        type: IInfoBlockType.concession,
        label: startCase(IInfoBlockType.concession),
      },
      {
        type: IInfoBlockType.fee,
        label: startCase(IInfoBlockType.fee),
      },
      {
        type: IInfoBlockType.sellers,
        label: startCase(IInfoBlockType.sellers),
      },
    ],
  },
];

export const infoBlockTypeMap = keyBy(infoBlockList, "type");

export const getInfoBlockItem = (type: string) => {
  const infoBlockItem = infoBlockList.reduce<
    | {
        type: IInfoBlockType;
        label: string;
        parentLabel: string;
      }
    | undefined
  >((infoBlockItem, { subItems, label }) => {
    const item = subItems.find((subItem) => subItem.type === type);

    if (item) {
      return { ...item, parentLabel: label };
    }
    return infoBlockItem;
  }, undefined);

  return infoBlockItem;
};
